import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PhoneInputComponent} from './phone-input.component';
import {FormsModule} from "@angular/forms";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";


@NgModule({
  declarations: [PhoneInputComponent],
  imports: [
    CommonModule,
    FormsModule,
    BsDropdownModule.forRoot(),
  ],
  exports: [PhoneInputComponent],
})
export class PhoneInputModule {
}
